import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './EventItem.m.sass';
import Avatar from '../../../../../components/Avatar';
import JobUpdatesIcon from '../../../../../assets/icons/job-updates.i.svg';
import TaskUpdatesIcon from '../../../../../assets/icons/task-updates.i.svg';
import IconSvg from '../../../../../components/IconSvg';
var dateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'numeric',
  day: '2-digit',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true
});
var EventItem = function EventItem(_ref) {
  var event = _ref.event;
  var isTaskUpdate = event.eventType === 'TASK_MARKED_COMPLETE' || event.eventType === 'TASK_MARKED_INCOMPLETE';
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.avatarContainer
  }, /*#__PURE__*/React.createElement(Avatar, {
    size: 32,
    url: event.triggeredBy && event.triggeredBy.avatar,
    fallback: event.triggeredBy && event.triggeredBy.avatarFallback
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.description,
    title: event.description
  }, event.description), /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", {
    className: isTaskUpdate ? styles.iconTaskUpdate : styles.iconJobUpdate
  }, isTaskUpdate ? /*#__PURE__*/React.createElement(IconSvg, {
    size: 24
  }, /*#__PURE__*/React.createElement(TaskUpdatesIcon, null)) : /*#__PURE__*/React.createElement(IconSvg, {
    size: 24
  }, /*#__PURE__*/React.createElement(JobUpdatesIcon, null))), /*#__PURE__*/React.createElement("div", {
    className: styles.date
  }, dateFormatter.format(event.dateCreated))))), event.reason && /*#__PURE__*/React.createElement("div", {
    className: styles.reason
  }, "\u201C", event.reason, "\u201D"));
};
export default observer(EventItem);
//# sourceMappingURL=index.js.map
